<table mat-table matSort [dataSource]="medicineDosageTypes" class="parcel-list">
   
    <ng-container matColumnDef="name">
        <th mat-header-cell *matHeaderCellDef>Name</th>
        <td mat-cell *matCellDef="let medicineDosageType"> {{medicineDosageType.additional_information}} </td>
    </ng-container>

    <ng-container matColumnDef="dosage_type">
        <th mat-header-cell *matHeaderCellDef>Type</th>
        <td mat-cell *matCellDef="let medicineDosageType"> 
            {{getDosageType(medicineDosageType)}}
        </td>
    </ng-container>

    <ng-container matColumnDef="created">
        <th mat-header-cell *matHeaderCellDef>Created</th>
        <td mat-cell *matCellDef="let medicineDosageType"> 
            {{utilsService.formatTime(medicineDosageType.created_at)}}
        </td>
    </ng-container>

    <ng-container matColumnDef="actions">
        <th mat-header-cell *matHeaderCellDef>&nbsp;</th>
        <td mat-cell *matCellDef="let medicineDosageType">
            <button class="me-2" color="primary" (click)="edit(medicineDosageType)" mat-raised-button>
                <mat-icon>info</mat-icon> Details
            </button>
            
           <ng-container *ngIf="!medicineDosageType.is_active">
            <button *authGroup="['SuperAdmin']"  (click)="activate(medicineDosageType)"  class="me-2"  color="accent" mat-flat-button>
                Activate
            </button>
           </ng-container>

            <ng-container *ngIf="medicineDosageType.is_active">
                <button *authGroup="['SuperAdmin']"  class="me-2" (click)="deActivate(medicineDosageType)" color="warn" mat-stroked-button>
                    Deactivate
                </button>
            </ng-container>

            <button *ngIf="!perm.isViewer()" class="me-2" (click)="delete(medicineDosageType)" color="warn" mat-flat-button>
                 Delete
            </button>
        </td>
    </ng-container>

    <tr mat-header-row *matHeaderRowDef="displayedColumns"></tr>
    <tr mat-row *matRowDef="let row; columns: displayedColumns;"></tr>
</table>

<mat-paginator
    [length]="total"
    [pageSize]="limit"
    [pageIndex]="page - 1"
    [pageSizeOptions]="[5, 10, 20, 50]"
    (page)="onPageChange($event)">
</mat-paginator>

<div class="d-flex align-items-center justify-content-between mt-2">
    <div>
        <button mat-stroked-button (click)="prevPage()" [disabled]="page <= 1">
            <mat-icon>chevron_left</mat-icon>
            Previous
        </button>
        <button class="ms-2" mat-stroked-button (click)="nextPage()" [disabled]="page >= lastPage">
            Next
            <mat-icon>chevron_right</mat-icon>
        </button>
    </div>
    <div>
        Page {{page}} of {{ lastPage }}
    </div>
</div>